import { Menu } from 'lucide-react';
import { ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerTrigger,
} from '@/components/ui/drawer';

import { cn } from '@/lib/utils';

import { navigation } from './constants';

export const NavigationMobileDrawer = ({
  light,
  children,
}: {
  light?: boolean;
  children: ReactNode;
}) => {
  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button
          variant={!light ? 'ghost' : 'outline'}
          className={cn('-m-2.5 p-2.5 lg:hidden', {
            'ring-0 shadow-none text-background': light,
          })}
        >
          <span className="sr-only">Open sidebar</span>
          <Menu className="h-6 w-6" aria-hidden="true" />
        </Button>
      </DrawerTrigger>
      <DrawerContent
        className={cn({
          'bg-white': light,
        })}
      >
        <div className="space-y-4 pt-6 p-4">
          {navigation.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={cn('flex items-center gap-2 text-foreground', {
                'text-background': light,
              })}
            >
              <span>{item.name}</span>
            </a>
          ))}
        </div>
        <DrawerFooter>
          <div className="w-fit text-background">{children}</div>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
